import { render, staticRenderFns } from "./gk_guide.vue?vue&type=template&id=7be31e74&scoped=true"
import script from "./gk_guide.vue?vue&type=script&lang=js"
export * from "./gk_guide.vue?vue&type=script&lang=js"
import style0 from "./gk_guide.vue?vue&type=style&index=0&id=7be31e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be31e74",
  null
  
)

export default component.exports